var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentDiv',[_c('PageTitle',[_vm._v("Start Live Stream")]),_c('p',[_vm._v(" To start a live video stream choose a stream name. Then select which users should have access to the stream ")]),_c('PageTitleDivider'),_c('VideoFeedDiv')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }